import DSHubModel from 'models/DSHubModel';

class BundleUtil {
  /**
   * Takes a bundle-relative path and converts it to a fully qualified URL
   * @param {string} path - path relative to the bundle (should start with a slash)
   */
  static getFullyQualifiedURL(path) {
    // url-loader will convert files to data uri's rather than returning the bundle-relative path
    // if we've received a data uri, just return it directly
    if (path.startsWith('data:')) {
      return path;
    }

    const {
      bundleLocation,
    } = DSHubModel;

    return bundleLocation + path;
  }
}

export default BundleUtil;



// WEBPACK FOOTER //
// ./src/utils/BundleUtil.js